const getters = {
	AUTH_TOKEN: ({ auth }) => auth._auth && auth._auth.token,
}
export default getters